import bugsnag from '@bugsnag/js'
const bugsnagClient = bugsnag({
  apiKey: '3a44de511793a37e26c0a59a604c13f5',
  notifyReleaseStages: [ 'production' ],
  releaseStage: typeof process.env === 'object' && process.env.NODE_ENV === 'development' ? 'development' : 'production'
})
export default bugsnagClient
